export enum Frequency {
  TenMinutes = "10min",
  QuarterHour = "15min",
  Hour = "hour",
  Day = "day",
  Month = "month",
  Year = "year"
}

export enum Unit {
  Watt = "W",
  WattHour = "Wh",
  Kilowatt = "kW",
  KilowattHour = "kWh",
  Megawatt = "MW",
  MegawattHour = "MWh",
  CubicMeter = "m³"
}

export enum MeasurementType {
  Single = "lastgang",
  Cumulative = "zählerstandsgang",
  Arbitrary = "beliebig_zählerstandsgang"
}

export enum Medium {
  Electricity = "electricity",
  Gas = "gas",
  Heat = "heat"
}

export enum ObjectName {
  Generator = "Erzeuger",
  Consumer = "Verbraucher",
  Storage = "Batteriespeicher",
  Person = "Unternehmen",
  Connection = "Netzverknüpfungspunkt",
  GasConnection = "Gas-Netzanschlusspunkt",
  Meter = "Zähler",
  GhostNode = "Verteilungspunkt",
  MarketLocation = "Marktlokation",
  MeteringLocation = "Messlokation",
  MeteringOrMarketLocation = "Mess- oder Marktlokation",
  Weighting = "Erzeugungsanteile"
}

export enum ObjectUrlName {
  Generators = "erzeuger",
  Consumers = "verbraucher",
  Storages = "batteriespeicher",
  Persons = "unternehmen",
  Connections = "netzverknuepfungspunkte",
  Meters = "zaehler",
  GhostNodes = "verteilungspuenkte",
  MarketLocations = "market-locations",
  MeteringLocations = "metering-locations",
  MeteringOrMarketLocations = "metering-or-market-locations",
  GasConnections = "gas-netzanschlusspunkt",
  Weightings = "erzeugungsanteile"
}

export const OBJECT_URL_NAMES_TO_OBJECT_NAMES: Record<
  ObjectUrlName,
  ObjectName
> = {
  [ObjectUrlName.Generators]: ObjectName.Generator,
  [ObjectUrlName.Consumers]: ObjectName.Consumer,
  [ObjectUrlName.Storages]: ObjectName.Storage,
  [ObjectUrlName.Persons]: ObjectName.Person,
  [ObjectUrlName.Connections]: ObjectName.Connection,
  [ObjectUrlName.GasConnections]: ObjectName.GasConnection,
  [ObjectUrlName.Meters]: ObjectName.Meter,
  [ObjectUrlName.GhostNodes]: ObjectName.GhostNode,
  [ObjectUrlName.MarketLocations]: ObjectName.MarketLocation,
  [ObjectUrlName.MeteringLocations]: ObjectName.MeteringLocation,
  [ObjectUrlName.MeteringOrMarketLocations]:
    ObjectName.MeteringOrMarketLocation,
  [ObjectUrlName.Weightings]: ObjectName.Weighting
};

const invertObject = (obj) =>
  Object.fromEntries(Object.entries(obj).map(([k, v]) => [v, k]));

export const OBJECT_NAMES_TO_OBJECT_URL_NAMES = invertObject(
  OBJECT_URL_NAMES_TO_OBJECT_NAMES
);

export const StructureDiagramObjectName = {
  ...ObjectName,
  Edge: "Verbindung"
};

export enum PhysicalSize {
  Energy = "Energie",
  Power = "Leistung",
  Volume = "Gasvolumen"
}

export enum SiteName {
  Optinode = "opti.node",
  Smarendo = "Smarendo",
  Alva = "Alva",
  Wavelr = "Wavelr"
}

export const SiteNamesWithOptinodeSupport = [
  SiteName.Optinode,
  SiteName.Smarendo,
  SiteName.Alva
];

export enum UserLicense {
  Analyzer = "analyzer",
  Manager = "manager"
}

export enum DataImportRequestType {
  METERING = "METERING_DATA",
  REDISPATCH = "REDISPATCH_DATA"
}

export enum MspCategory {
  LiefEdi = "lief-edi",
  EsaEdi = "esa-edi",
  EsaReq = "esa-req",
  CSV = "csv",
  Unknown = "unknown",
  Reluctant = "reluctant"
}

export enum MspImportFrequency {
  Yearly = "yearly",
  Monthly = "monthly",
  Daily = "daily",
  Unknown = "unknown"
}

export enum SupplyType {
  PARTIAL_SUPPLY = "partial",
  FULL_SUPPLY = "full"
}
